import angular from 'angular';

import '../../core/main/filter/country_date/filter';
import '../../core/main/factory/analytics';
import '../../main/factory/authentication';
import '../../main/factory/tax_invoice';
import { getInvoiceUrl, getPaymentTerms } from '../../main/factory/tax_invoice';

document.write(require('./view.html').default);
import './style.scss';

angular.module("merchant.application.module.taxInvoice", [
]).controller("merchant.application.module.taxInvoice.controller", [
    "$scope", "$controller",
    "merchant.application.main.factory.authentication",
    "core.application.main.factory.analytics",
    function($scope, $controller, Authentication, Analytics) {
        $controller("merchant.application.module.controller", {$scope: $scope});

        if (! $scope.model.taxInvoice) {
            $scope.model.taxInvoice = {};
        }
        if (!$scope.model.paymentTerms) {
            $scope.model.paymentTerms = null;
        }

        $scope.showPaymentTerms = function () {
            return $scope.model.channel === "IN_STORE_CARD" && Authentication.countryCode() === "US" && !!$scope.model.paymentTerms;
        }

        $scope.isTaxInvoice = function() {
            return $scope.model.channel !== "IN_STORE_CARD" && $scope.model.channel !== "IN_STORE_CARD_ONLINE";
        }

        $scope.getPaymentTerms = function () {
            const merchantId = Authentication.merchantId()
            if (!!merchantId && $scope.model.channel === "IN_STORE_CARD") {
                getPaymentTerms(merchantId).then(result => {
                    $scope.model.paymentTerms = result.data;
                    $scope.$apply();
                })

            }
        }

        $scope.isDateValidInPeriod = function(date) {
            var beginningOfPeriod, beginningOfDefaultDate;
            beginningOfPeriod = $scope.beginningOfPeriod(date);
            beginningOfDefaultDate = $scope.beginningOfPeriod($scope.model.taxInvoice.defaultDate);
            if (! beginningOfPeriod || ! beginningOfDefaultDate) {
                return false;
            }
            if (beginningOfPeriod > beginningOfDefaultDate) {
                // we aren't allowed the current time period or any after it
                // only the time period before this one and any before it are allowed
                // e.g. If today is 23/12/2014 and the period is monthly
                // then only november and previous to that are valid
                return false;
            }
            return (
                // the date needs to be at the beginning of the period
                date.getFullYear() === beginningOfPeriod.getFullYear() &&
                date.getMonth() === beginningOfPeriod.getMonth() &&
                date.getDate() === beginningOfPeriod.getDate()
            );
        };

        $scope.beginningOfPeriod = function(date) {
            // given a date find the beginning of the period
            // e.g. if the period is monthly and the given date is 04/11/2014
            // then return 01/11/2014
            var beginning = null;
            if (! date) {
                return null;
            }
            switch ($scope.model.taxInvoice.period) {
                case $scope.model.taxInvoice.periods.DAILY:
                    // a day is the smallest time period so we are already at the beginning
                    beginning = date;
                    break;
                case $scope.model.taxInvoice.periods.WEEKLY:
                    // should be the first day of the week (Monday)
                    beginning = new Date(date.getFullYear(), date.getMonth());
                    beginning.setDate(date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1));
                    break;
                case $scope.model.taxInvoice.periods.MONTHLY:
                    // should be the first day of the month
                    beginning = new Date(date.getFullYear(), date.getMonth(), 1);
                    break;
            }
            if (beginning) {
                // PAYL-6922 Remove the time component of the date, to avoid issues with daylight savings in the tests.
                // The smallest date format is daily so the time component is not needed
                beginning.setHours(0, 0, 0, 0);
            }
            return beginning;
        };

        $scope.endOfPeriod = function(date) {
            // given a date find the end of the period
            // e.g. if the period is monthly and the given date is 04/11/2014
            // then return 30/11/2014
            var end = null;
            if (! date) {
                return null;
            }
            switch ($scope.model.taxInvoice.period) {
                case $scope.model.taxInvoice.periods.DAILY:
                    // a day is the smallest time frame so we are already at the end
                    end = date;
                    break;
                case $scope.model.taxInvoice.periods.WEEKLY:
                    // should be end of the week
                    end = new Date(date.getFullYear(), date.getMonth());
                    end.setDate(date.getDate() - date.getDay() + 7); // 7 days in a week
                    break;
                case $scope.model.taxInvoice.periods.MONTHLY:
                    // should be end of the month
                    end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                    break;
            }
            if (end) {
                // PAYL-6922 Remove the time component of the date, to avoid issues with daylight savings in the tests.
                // The smallest date format is daily so the time component is not needed
                end.setHours(0, 0, 0, 0);
            }
            return end;
        };

        $scope.configureDefaultDate = function() {
            // we always need to be one time period behind the current time
            // period for example if the time period is "monthly" and if it's
            // January 2015 then the default should be Dec 2014
            var defaultDate = new Date();
            switch ($scope.model.taxInvoice.period) {
                case $scope.model.taxInvoice.periods.DAILY:
                    defaultDate.setDate(defaultDate.getDate() - 1); // previous day
                    break;
                case $scope.model.taxInvoice.periods.WEEKLY:
                    defaultDate.setDate(defaultDate.getDate() - 7); // previous week (7 days in a week)
                    break;
                case $scope.model.taxInvoice.periods.MONTHLY:
                    // we need to set the date as the first day of the current month,
                    // so that defaultDate.setMonth(defaultDate.getMonth() - 1) will be guaranteed
                    // to set the date to the previous month,
                    // otherwise, for example, Mar 30 will become Feb 30 which is invalid and will be converted to Mar 2.
                    defaultDate.setDate(1);
                    defaultDate.setMonth(defaultDate.getMonth() - 1); // previous month
                    break;
            }
            // PAYL-6922 Remove the time component of the date, to avoid issues with daylight savings in the tests.
            // The smallest date format is daily so the time component is not needed
            defaultDate.setHours(0, 0, 0, 0);
            return defaultDate;
        };

        $scope.getInvoiceUrl = function() {
            if (! $scope.model.taxInvoice.fromDate || ! $scope.model.taxInvoice.toDate) {
                return "#";
            }
            return getInvoiceUrl(
                Authentication.merchantId(),
                $scope.model.taxInvoice.fromDate,
                $scope.model.taxInvoice.toDate,
                $scope.model.channel
            );
        };

        $scope.model.taxInvoice.periods = {
            DAILY: "Daily",
            WEEKLY: "Weekly",
            MONTHLY: "Monthly",
        };

        $scope.model.taxInvoice.period = $scope.model.taxInvoice.periods.MONTHLY;

        $scope.$watch("model.taxInvoice.period", function() {
            $scope.model.taxInvoice.defaultDate = $scope.configureDefaultDate();
        });

        $scope.$watch("model.taxInvoice.defaultDate", function(defaultDate) {
            $scope.model.taxInvoice.fromDate = $scope.beginningOfPeriod(defaultDate);
        }, true); // deep object watch

        $scope.$watch("model.taxInvoice.fromDate", function(fromDate) {
            $scope.model.taxInvoice.toDate = $scope.endOfPeriod(fromDate);
        }, true); // deep object watch

        $scope.$watch("model.taxInvoice.channel", function () {
            $scope.getPaymentTerms();
        });


        $scope.sendAmplitudeEvent = function(eventName) {
            Analytics.sendAmplitudeEvent(eventName, {
                merchantId: Authentication.merchantId(),
                fromDate: $scope.model.taxInvoice.fromDate,
                toDate: $scope.model.taxInvoice.toDate,
                period: $scope.model.taxInvoice.period
            })
        }

        const country = Authentication.countryCode().toUpperCase();
        $scope.model.showDaily = country !== 'ES';
        $scope.model.showWeekly = country !== 'ES';
        $scope.model.showMonthly = true;

    }
]);
